export function todayISO() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}

export function isUpcomingEvent(event) {
  return Boolean(event?.date) && event.date >= todayISO();
}

export function splitEvents(events = []) {
  const upcoming = [];
  const past = [];
  events.forEach((event) => {
    if (isUpcomingEvent(event)) upcoming.push(event);
    else past.push(event);
  });
  upcoming.sort((a, b) => String(a.date).localeCompare(String(b.date)));
  past.sort((a, b) => String(b.date).localeCompare(String(a.date)));
  return { upcoming, past };
}

export function formatEventDate(dateStr) {
  if (!dateStr) return "";
  const [year, month, day] = String(dateStr).split("-").map(Number);
  if (!year || !month || !day) return dateStr;
  return new Date(year, month - 1, day).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function normalizeEvent(event = {}, index = 0) {
  return {
    id: event.id || `event-${index + 1}-${event.date || Date.now()}`,
    title: event.title || "",
    date: event.date || "",
    text: event.text || "",
    location: event.location || "",
  };
}
